<template>
    <div>
        <vue-headful :title="$t('themes_of_thesis')" />
        <div v-if="data.data_none" >
            <div v-if="data_data==[]">
                <p>Text</p>
            </div>
            <div else>
                <vs-table :data="data_data" >

                    <template slot="thead">
                        <vs-th></vs-th>
                        <vs-th>Тема дипломной работы (каз/рус.англ)</vs-th>
                        <vs-th>Руководитель</vs-th>
                        <vs-th>Руководитель извне</vs-th>
                        <vs-th>Виды выпускной работы</vs-th>
                    </template>

                    <template>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data_data">
                            <vs-td style="text-align: center;">
                                <!--                        <vs-checkbox type="radio"  :vs-value="putData" v-model="putData" @change="test"></vs-checkbox>-->
                                <vs-radio v-model="putData" :vs-value="data_data[indextr]"></vs-radio>
                            </vs-td>
                            <vs-td :data="data_data[indextr].name" style="width: 400px;">
                                {{ data_data[indextr].name }}
                            </vs-td>

                            <vs-td :data="data_data[indextr].supervisors_text" style="width: 400px;">
                                {{ clone_data[indextr] }}
                            </vs-td>

                            <vs-td :data="data_data[indextr].supervisor_leader">
                                {{ data_data[indextr].supervisor_leader }}
                            </vs-td>

                            <vs-td :data="data_data[indextr].types_of_graduation_work">
                                <div v-if="data_data[indextr].types_of_graduation_work">
                                    {{ data_data[indextr].types_of_graduation_work.name }}
                                </div>
                            </vs-td>

                        </vs-tr>
                    </template>
                    <!--        {{ selected }}-->
                    <!--            {{ putData }}-->
                </vs-table>
            <div v-if="data_data.data_none">
                <vs-button

                    style="right: 30px;position:absolute;margin-top: 10px;"
                    icon-pack="feather"
                    class="save_btn"
                    @click="saveHandler()"
                    icon="icon-save">
                    {{ $t('save') }}
                </vs-button>
            </div>
            </div>
        </div>
        <div v-if="!data.data_none">
            <vx-card>
                <vs-row>
                    <vs-col style="text-align: center;padding: 5px 20px;">
                        <p style="font-size: 17px;">

                            Вы выбрали дипломную работу {{ data_name }}<br>
                            С руководителем {{ supervisors_text }}
                        </p>
                    </vs-col>
                </vs-row>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected: [],
            'tableList': [
                'vs-th: Component',
                'vs-tr: Component',
                'vs-td: Component',
                'thread: Slot',
                'tbody: Slot',
                'header: Slot'
            ],
            data: [],
            putData: [],
            data_data: [],
            clone_data:[]
        }
    },
    created() {
        this.createdData()
        // console.log(this.data)
    },
    watch: {
        putData() {
            // console.log(this.putData)
        }
    },
    computed: {
        data_name() {
            if (this.data.length != 0) {
                let kk = this.data.data.name_kk ? '/' + this.data.data.name_kk : ''
                let en = this.data.data.name_en ? '/' + this.data.data.name_en : ''
                return this.data.data.name_ru + kk + en
            }

        },
        supervisors_text() {
            if (this.data.length != 0) {
                let supervisors_text = ''
                this.data.data.supervisors.forEach((item)=>{
                    var zapi = supervisors_text==''?'':','
                    // console.log(zapi)
                    supervisors_text  = supervisors_text +zapi+ item.supervisors
                })
                // console.log(supervisors_text)
                return supervisors_text+ ',' +this.data.data.supervisor_leader
            }
        },
        data_true_false(){
            if(data_data==[]){
                return false
            }else{
                return true
            }
        }
    },
    methods: {
        async createdData() {
            this.$vs.loading()
            // let vse_names = []
            await this.$http.get('advisors/get_themes_of_theses_view', {params: {profile: this.$store.state.user.user?.profileId}}).then(
                (res) => (
                    this.data = res.data,
                    this.data_data = res.data.data
                )

            )
            // console.log(this.data_data)
            if (Array.isArray(this.data_data)) {
                this.data_data.forEach((item)=>{
                    var names = ''
                    var zapi = names==''?'':','
                    item.supervisors.forEach((obj)=>{
                        names = names+zapi+obj.supervisors
                    })
                    this.clone_data.push(names)
                })
            }
            // if (this.data_data){
            //     this.data_data.forEach((item)=>{
            //         var names = ''
            //         var zapi = names==''?'':','
            //         item.supervisors.forEach((obj)=>{
            //             names = names+zapi+obj.supervisors
            //         })
            //         this.clone_data.push(names)
            //     })
            // }

            // console.log(this.clone_data)

            this.$vs.loading.close()
        },
        test(e) {
            this.putData = []
            // console.log(e)
            this.putData.push(e);
            // this.putData.push(e.value);

            // console.log(this.putData)
            // this.putData = null
            // console.log(this.putData)
            // this.putData.push(val);
            // console.log(val)
            // console.log(this.putData)
            // this.putData ='';
            // console.log(val)
            // this.putData = await val
            // console.log(this.putData )
        },
        async saveHandler() {
            this.$vs.loading()
            await this.$http.put(
                `advisors/put_themes_of_theses/` + this.putData.uid + `/`,
                {student: this.$store.state.user.user?.profileId}
            )
            this.createdData()
            this.$vs.loading.close()

        },
        // changeSelected(){
        //     console.log('sjaisjisa')
        // }
    }
}
</script>

<style lang="scss" scoped>
.ag-header-cell-label {
    justify-content: center;
}

.grid-cell-centered {
    justify-content: center;
}

.ag-theme-balham .ag-cell-inline-editing {
    height: 100%;
}

.cell-wrap-text {
    white-space: normal !important;
    width: 400px;
    max-width: 400px;
}
</style>
